import "./resume-purchase.scss";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import {
  PaymentAmericanExpress,
  PaymentApplePay,
  PaymentGooglePay,
  PaymentMaestro,
  PaymentMastercard,
  PaymentPaypal,
  PaymentSatisPay,
  PaymentVisa,
} from "src/assets";
import { atomPolicy } from "src/storage";
import { Formik, FormikInsurance } from "src/types";
import { useScrollToError } from "src/ui/pages/data-entry/handlers/scroll-to-error.hook";
import { GIVE_BASE_CODE } from "src/config";

export const useResumePurchase = ({
  formik,
}: {
  formik: Formik<FormikInsurance>;
}) => {
  const { t } = useTranslation();

  const { values } = formik;
  const policy = useRecoilValue(atomPolicy);

  const coverageTypeLabel = t(
    values.coverageTypeRadios === GIVE_BASE_CODE
      ? "commons.section_2_base_title"
      : "commons.section_2_plus_title"
  );

  const { triggerFormikCheck } = useScrollToError(formik);

  return {
    coverageTypeLabel,
    policy,
    t,
    triggerFormikCheck,
  };
};

export const useResumePurchaseContent = ({
  formik,
}: {
  formik: Formik<FormikInsurance>;
}) => {
  const { t } = useTranslation();

  const { values } = formik;
  const resumePurchase: { [key: string]: string }[] = [
    {
      key: t("data_entry.coverage_start_date"),
      value: values.coverageStartDate,
    },
    { key: t("data_entry.coverage_end_date"), value: values.coverageEndDate },
    {
      key: t("data_entry.coverage_insured_number"),
      value: values.insuredNumber,
    },
    {
      key: t("data_entry.insured_total_days_number"),
      value: values.insuredDaysNumber,
    },
  ];

  const paymentMethodList = [
    PaymentVisa,
    PaymentMastercard,
    PaymentMaestro,
    PaymentPaypal,
    PaymentAmericanExpress,
    PaymentGooglePay,
    PaymentApplePay,
    PaymentSatisPay,
  ];

  return { resumePurchase, paymentMethodList };
};
